<template>

	<el-container>
		<el-header>
			<!-- <img style="margin-top: 12px;max-width: 40px; float: left;" @click="tomain()" :src='"/img/webimg/back.png"' alt=""> -->
			<el-button style="margin-top: 4px;font-size: 28px; float: left;color:#000000;" @click="tomain()"
				icon="el-icon-arrow-left" type="text"></el-button>
			<span class="header_h2">报告 </span>
		</el-header>
		<el-main>
			<div v-if="norpt">没有已完成的体检报告哟！</div>
			<el-row>
				<el-col :span="24" v-for="cus in cuslist">
					<div>
						<el-row class="myrow" style="margin-top: 5px;margin-bottom: 2px;">
							<el-col :span="6">
								<p class="myrowp">Date：</p>
								<p class="myrowp">姓名：</p>
								<p class="myrowp">ID：</p>
							</el-col>
							<el-col :span="12">
								<p class="myrowp">{{formatdate(cus.createtime)}}</p>
								<p class="myrowp">{{cus.cusname}}</p>
								<p class="myrowp">{{cus.checkno}}</p>
							</el-col>
							<el-col :span="6">
								<el-button type="primary" size="mini" round @click="showrpt(cus)">体检报告</el-button>
								<br><br>
								<el-button type="warning" size="mini" round @click="showrptyg(cus)">乙肝报告</el-button>
							</el-col>
						</el-row>
					</div>

				</el-col>
			</el-row>
			<div style="color: red;">{{ errorMsg }}</div>
			<div style="height: 500px;" v-if="pSrc != ''">
				<!-- <el-button v-if="isinwx != true" type="primary" size="mini" round @click="downloadPDF(downStr)">下载报告</el-button>
				<span v-if="isinwx">如需下载报告，请点击右上角‘... ’按钮，选择'在浏览器中打开',重新登录。</span>
				<span v-if="isinwx != true">如需下载报告，请点击右侧‘>>’按钮,选择'下载'。</span> -->
				<!-- http://localhost:8080/#/HistoryReport?mobile=1380013800 -->
				
				<div v-if="isShow" style="height: 100%;">
					<a :href="downStr" style="width: 100px;margin-left: 5px;unde">下载PDF报告</a>
					<!-- <el-link :href="downStr" target="_blank" type="primary" style="margin-bottom: 15px;">下载PDF报告</el-link> -->
					<embed ref="iframe" v-if="pSrc != ''" scrolling="yes" :src="pSrc" width="100%" height="100%" frameborder="0"></embed>
				</div>
			
			</div>

		</el-main>
	</el-container>
</template>

<script>
	import rpt from '../../apifunction/CusReport.js'
	export default {
		created() {
			this.mobile = this.$route.query.mobile;
			this.initdata();
			this.is_weixin();
		},
		data() {
			return {
				downStr:'',
				isinwx:true,
				pSrc: '',
				cuslist: [],
				mobile: '',
				norpt: false,
				errorMsg: '',
				isShow: false

			};
		},
		methods: {
			initdata() {
				rpt.GetCusReported(this.mobile)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						//alert(JSON.stringify(res.data));
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.cuslist = JSON.parse(ent.Data);
							} else
								this.norpt = true;
						}
					});
			},
			downloadEvt(url, fileName = '下载报告') {
			      const el = document.createElement('a');
			      el.style.display = 'none';
			      el.setAttribute('target', '_blank');
			     /**
			       * download的属性是HTML5新增的属性
			       * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
			       * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
			       * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
			       */
			      fileName && el.setAttribute('download', fileName);
			      el.href = url;
			      console.log(el);
			      document.body.appendChild(el);
			      el.click();
			      document.body.removeChild(el);
			    },
			is_weixin() {
			  var ua = window.navigator.userAgent.toLowerCase();
			  if (ua.match(/MicroMessenger/i) == "micromessenger") {
			    // console.log("微信浏览器");
			    this.isinwx= true;
			  } else {
			    // console.log("不是微信浏览器");
			    this.isinwx= false;
			  }
			},
			formatdate(d) {
				return this.$moment(d).format("YYYY-MM-DD");
			},
			showrpt(cus) {
				this.pSrc == '';
                this.errorMsg= '';
				this.isShow = false;
				rpt.GetGRReportIsExists(cus.corpid, cus.checkno).then(res => {
					let ent = JSON.parse(JSON.stringify(res.data))
					//alert(JSON.stringify(res.data));
					if (ent.Flag == 'success') {
						this.isShow = true;
					    let url = rpt.GetGRReportUrl(cus.corpid, cus.checkno);
				        //  var loadingTask = pdf.createLoadingTask(url);
				        //  loadingTask.promise.then(pdf => {
				        //    this.numPages = pdf.numPages;
				        //  });
				        // this.pSrc = url;
				        //this.numPages=pdf.numPages;
				        //this.downStr=url+'#pdfjs.action=download';
				        this.downStr=url;
				        //alert(this.downStr);
				        this.pSrc = '/pdf/web/viewer.html?file=' + url;
				        // alert(this.pSrc )
		    
					}else{
						this.errorMsg= '体检报告不存在！';
					}
				});


			},
			showrptyg(cus) {
				this.pSrc == '';
				this.errorMsg= '';
				this.isShow = false;
				rpt.GetYGReportIsExists(cus.corpid, cus.checkno).then(res => {
					let ent = JSON.parse(JSON.stringify(res.data))
					//alert(JSON.stringify(res.data));
					if (ent.Flag == 'success') {
						this.isShow = true;
				        let url = rpt.GetYGReportUrl(cus.corpid, cus.checkno);
				        // this.pSrc = url;
				        this.downStr=url;
				        //alert(this.downStr);
				        this.pSrc = '/pdf/web/viewer.html?file=' + url;
					}else{
						this.errorMsg= '乙肝报告不存在！';
					}
				});


			},
			tomain() {
				var data = {
					path: '/mainbook',
					query: {
						mobile: this.mobile,
						showmenu: true
					}

				}
				this.$router.push(data)
			}
		}
	}
</script>

<style>
	/* .pdf-header {
		height: 0.98rem;
		width: 100%;
		background: white;
		position: fixed;
	}

	.reten {
		width: 7rem;
		line-height: 1rem;
		padding: 0 0.28rem;
		font-size: 0.3rem;
		color: #bebebe;
	}

	.router {
		position: absolute;
		width: 100%;
	} */

	/* 	.overall{
		height:80rem;
		-webkit-overflow-scrolling: touch;
		overflow-y: scroll;
		position: absolute;
		top: 0;
		right: 0;
		left: 0;

	} */

	/* .overall iframe {
		position: fixed;
		top: 4rem;
		bottom: 1rem;
		height: 50%;
		width: 50%
	} */
</style>
